@switch (cardStyle()) {
  @case ('icon') {
    <div class="mobi-ui-card-silent mobi-ui-height-full no-heading-spacing">
      <div class="mobi-ui-width-full mobi-ui-text-center">
        @if (cardIllustration()) {
          <div class="card-icon-wrapper">
            <mobi-ui-illustration-major [illustration]="cardIllustration()!" />
          </div>
        }
        @if (cardIcon()) {
          <div class="card-icon-wrapper">
            <mobi-ui-icon-major [name]="cardIcon()!" />
          </div>
        }
        <h5
          class="mobi-ui-text-block-label-minor mobi-ui-text-inked mobi-ui-font-size-200"
        >
          {{ cardTitle() }}
        </h5>
        @if (cardText()) {
          <mobi-text [data]="cardText()!" class="mobi-ui-font-size-200" />
        }
      </div>
    </div>
  }
  @case ('info') {
    <div class="flex justify-start no-heading-spacing">
      @if (cardIcon()) {
        <mobi-ui-icon-major
          [name]="cardIcon()!"
          class="mobi-ui-margin-r-xxs !pt-0 top-[-5px]"
        />
      }
      <div>
        <div>
          <h5 class="mobi-ui-font-sm mobi-ui-font-bold mobi-ui-font-realist">
            {{ cardTitle() }}
          </h5>
          <span>{{ cardText() }}</span>
        </div>
      </div>
    </div>
  }
  @case ('swipe') {
    <div
      class="mobi-ui-section-minor h-full w-full mobi-ui-padding-lg no-heading-spacing"
    >
      <div class="h-full">
        @if (cardNumber() && cardTotal() && breakpoint.smMax()) {
          <span
            class="mobi-ui-font-tisa mobi-ui-font-size-200 mobi-ui-text-inked mobi-ui-font-bold"
          >
            {{ cardNumber() }}
            <span class="mobi-ui-ink-grey mobi-ui-text-inked"
              >&nbsp;/&nbsp;{{ cardTotal() }}</span
            >
          </span>
        } @else {
          <span
            class="rounded-full bg-signature inline-flex items-center justify-center mobi-ui-margin-xxxs"
          >
            <mobi-ui-icon-major
              name="tik_checkbox"
              size="md"
              class="text-common-text-contrast"
            />
          </span>
        }
        @if (cardTitle()) {
          <mobi-heading-select
            [title]="cardTitle()!"
            [headingType]="cardTitleSize() || 'h5'"
            headingStyle="h4"
            additionalStyling="mobi-ui-padding-y-sm mobi-ui-text-inked"
          />
        }

        @if (cardText()) {
          <mobi-text [data]="cardText()!" class="mobi-ui-font-size-200 [&_>p:!mb-0]" />
        }
      </div>
    </div>
  }
}
